// Pages must never crash on what the server sends: a field can be missing, null, a number where text was expected, or an object where it used to be text
// (the chauffeur on a ride is now a card: {name, vehicle, ...}). These turn any value into something safe to show.
export const str = (v) => (typeof v === 'string' ? v : typeof v === 'number' && Number.isFinite(v) ? String(v) : '');
export const num = (v, fallback = 0) => { const n = typeof v === 'boolean' ? NaN : Number(v); return Number.isFinite(n) ? n : fallback; };
export const money = (v) => num(v).toFixed(2);

// The chauffeur's name from a name, or a card object, or nothing.
export const driverName = (d) => (typeof d === 'string' ? d.trim() : d && typeof d === 'object' ? str(d.name).trim() : '');

// A ride as the pages need it: text fields are text, numbers are numbers, the chauffeur is a name, the rating is an object or null. Everything else rides along untouched.
export function safeRide(r) {
  const x = r && typeof r === 'object' ? r : {};
  const rating = x.rating && typeof x.rating === 'object' ? x.rating : null;
  return {
    ...x,
    id: str(x.id) || str(x.reference),
    reference: str(x.reference),
    pickupAddress: str(x.pickupAddress) || str(x.pickup_name),
    dropoffAddress: str(x.dropoffAddress) || str(x.dropoff_name),
    estimatedFare: num(x.estimatedFare),
    status: str(x.status),
    paymentStatus: str(x.paymentStatus),
    vehicleModel: str(x.vehicleModel),
    scheduledTime: str(x.scheduledTime),
    createdAt: str(x.createdAt),
    driver: driverName(x.driver),
    tipAmount: num(x.tipAmount),
    rating,
  };
}

export const safeRides = (list) => (Array.isArray(list) ? list : []).filter((r) => r && typeof r === 'object').map(safeRide);

// "Oct 20, 4:30 PM", or '' when the date is missing or not a date (never throws).
export function shortDate(value, opts = { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  try { return d.toLocaleDateString('en-US', opts); } catch (e) { return ''; }
}
